import React, { useEffect, useState } from 'react';
import { getSessionStorage, setSessionStorage, validateFunctionalForm } from '../../utils';
import constant from '../../constant';
import { v3_profile_detail } from '../../actions/v3/user';

const LeaveApplicationForm = ({ data, onSubmit, title, leaveTypes = [], userGender = 'All', siteLocations, designations = [], cancelUrl = constant.Authedcomponent.leaveApplied.url }) => {

    const [ud, set_ud] = useState({})

    const [state, setState] = useState({
        siteLocation: { name: 'siteLocation', value: data?.SITE_LOCATION || '', isRequired: true, error: '' },
        applicationDate: { name: 'applicationDate', value: data?.APPLICATION_DATE || '', isRequired: true, error: '' },
        jobTitle: { name: 'jobTitle', value: data?.JOB_TITLE || '', isRequired: true, error: '' },
        leaveTypeId: { name: 'leaveTypeId', value: data?.LEAVE_TYPE_ID || '', isRequired: true, error: '' },
        leaveFrom: { name: 'leaveFrom', value: data?.LEAVE_FROM || '', isRequired: true, error: '' },
        leaveTo: { name: 'leaveTo', value: data?.LEAVE_TO || '', isRequired: true, error: '' },
        totalDays: { name: 'totalDays', value: data?.TOTAL_DAYS || '', isRequired: true, error: '' },
        note: { name: 'note', value: data?.NOTE || '', isRequired: false, error: '' },
        applicantSignature: { name: 'applicantSignature', value: data?.APPLICANT_SIGNATURE || '', isRequired: true, error: '' },
        status: { name: 'status', value: data?.STATUS || 'PENDING', isRequired: true, error: '' },
    });

    useEffect(() => {
        // Editing a leave must retain the applicant details from the record, not
        // replace them with the profile of the administrator doing the edit.
        if (data?.ID) return;

        if (getSessionStorage(constant.keys.userDetails)) {
            set_ud(JSON.parse(atob(getSessionStorage(constant.keys.userDetails))))
        }
        else {

            v3_profile_detail().then((res) => {
                if (res.status) {
                    set_ud(JSON.parse(atob(res.result)))
                    setSessionStorage(constant.keys.userDetails, res.result)

                }
            })
        }

    }, [data?.ID])

    useEffect(() => {
        if (data?.ID) return;

        setState(prev => {
            const updatedState = {
                ...prev,
                ['jobTitle']: {
                    ...prev['jobTitle'],
                    value: ud.DESIGNATION_NAME,
                },
                ['applicantSignature']: {
                    ...prev['applicantSignature'],
                    value: ud.fullName,
                }
            };
            return updatedState;
        });
    }, [data?.ID, ud])

    const handleChange = (e) => {
        debugger
        const { name, value } = e.target;
        if (name === 'applicantSignature') {
            return
        }
        setState(prev => {
            const updatedState = {
                ...prev,
                [name]: {
                    ...prev[name],
                    value,
                    error: prev[name].isRequired && !value ? 'This field is required' : ''
                }
            };

            // Auto calculate total days if leaveFrom and leaveTo are both present
            const leaveFrom = name === 'leaveFrom' ? value : updatedState.leaveFrom.value;
            const leaveTo = name === 'leaveTo' ? value : updatedState.leaveTo.value;

            if (leaveFrom && leaveTo) {
                const from = new Date(leaveFrom);
                const to = new Date(leaveTo);
                const diffTime = to - from;

                if (!isNaN(diffTime)) {
                    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;// +1 to include both dates
                    if(name === 'totalDays') {
                        updatedState.totalDays = {
                            ...prev.totalDays,
                            value: value,
                            error: days > 0 ? '' : 'Leave To should be after Leave From',
                        };
                    } else {
                        updatedState.totalDays = {
                            ...prev.totalDays,
                            // value: days > 0 ? days : '',
                            // value: '',
                            error: days > 0 ? '' : 'Leave To should be after Leave From',
                        };
                    }
                }
            }

            return updatedState;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        debugger
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };


    // Filter leave types based on gender
    const filteredLeaveTypes = leaveTypes.filter(
        (type) => type.GENDER_SPECIFIC === 'All' || type.GENDER_SPECIFIC === userGender
    );



    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">

                <div className="col-md-6 mb-3">
                    <label>Site Location <span className='text-danger'>*</span></label>
                    <select
                        name={state.siteLocation.name}
                        value={state.siteLocation.value}
                        onChange={handleChange}
                        className={`form-control ${state.siteLocation.error ? 'is-invalid' : ''}`}
                    >
                        <option value="">Select Site Location</option>
                        {siteLocations.map((type) => (
                            <option key={type.ID} value={type.ID}>
                                {type.LOCATION_NAME}
                            </option>
                        ))}
                    </select>
                    {state.siteLocation.error && <div className="invalid-feedback">{state.siteLocation.error}</div>}
                </div>
                {[
                    { label: 'Application Date', name: 'applicationDate', type: 'date' },
                    { label: 'Designation ', name: 'jobTitle', placeholder: 'Enter designation' },
                    { label: 'Leave From', name: 'leaveFrom', type: 'date' },
                    { label: 'Leave To', name: 'leaveTo', type: 'date' },
                    { label: 'Total Days', name: 'totalDays', type: 'number', placeholder: 'Number of days' },
                    { label: 'Applicant Signature', name: 'applicantSignature', placeholder: 'Your name or signature' },
                ].map(({ label, name, type = 'text', placeholder = '' }) => name === 'jobTitle' ?
                    <div className="col-md-6 mb-3">
                        <label> {label} <span className='text-danger'>*</span></label>
                        <select
                            name={name}
                            value={state.jobTitle.value}
                            onChange={handleChange}
                            className={`form-select ${state.jobTitle.error ? 'is-invalid' : ''}`}
                        >
                            <option value="">Select Designations</option>
                            {designations.map((designation) => (
                                <option key={designation.ID} value={designation.DESIGNATION_NAME}>
                                    {designation.DESIGNATION_NAME}
                                </option>
                            ))}
                        </select>
                        {state.leaveTypeId.error && <div className="invalid-feedback">{state.leaveTypeId.error}</div>}
                    </div> : (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} <span className='text-danger'>*</span></label>
                        <input
                            type={type}
                            name={state[name].name}
                            value={state[name].value}
                            onChange={handleChange}
                            placeholder={placeholder}
                            className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
                        />
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-6 mb-3">
                    <label>Leave Type <span className='text-danger'>*</span></label>
                    <select
                        name={state.leaveTypeId.name}
                        value={state.leaveTypeId.value}
                        onChange={handleChange}
                        className={`form-select ${state.leaveTypeId.error ? 'is-invalid' : ''}`}
                    >
                        <option value="">Select Leave Type</option>
                        {filteredLeaveTypes.map((type) => (
                            <option key={type.ID} value={type.ID}>
                                {type.LEAVE_TYPE_NAME}
                            </option>
                        ))}
                    </select>
                    {state.leaveTypeId.error && <div className="invalid-feedback">{state.leaveTypeId.error}</div>}
                </div>

                <div className="col-md-12 mb-3">
                    <label>Note</label>
                    <textarea
                        name={state.note.name}
                        value={state.note.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="2"
                        placeholder="Any additional notes (optional)"
                    />
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Submit</button>
                <a className="btn btn-danger text-white" href={cancelUrl}>Cancel</a>

            </div>
        </form>
    );
};

export default LeaveApplicationForm;
